import type { ComponentType, SVGProps } from 'react'

import {
  IconExBanknote,
  IconExBriefcase,
  IconExCalendar,
  IconExCamera,
  IconExCampus,
  IconExCompass,
  IconExDiscount,
  IconExFile,
  IconExGlobe,
  IconExHealth,
  IconExLibrary,
  IconExNewspaper,
  IconExPaperclip,
  IconExProducts,
  IconExSport,
  IconExStudent,
  IconExUser,
  IconExNeptun,
  IconExCareerOS,
  IconExMoodle,
  IconExEdit,
  IconExProgrames,
  IconExIT,
  IconExFeedback,
  IconExFresher,
  IconExSchedule,
  IconExMobilites,
  IconExDormitory,
  IconExCompetitions,
  IconExStudentAssociations,
  IconExColleges,
  IconExScience,
  IconExMentor,
  IconExWellBeing,
} from '@/components/ui/icons'
import type { ProductIcon } from '@/packages/explore/types'

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>

/** Figma glyph name → the exported vector. */
export const PRODUCT_ICON: Record<ProductIcon, IconComponent> = {
  banknote: IconExBanknote,
  briefcase: IconExBriefcase,
  calendar: IconExCalendar,
  camera: IconExCamera,
  campus: IconExCampus,
  compass: IconExCompass,
  discount: IconExDiscount,
  file: IconExFile,
  globe: IconExGlobe,
  health: IconExHealth,
  library: IconExLibrary,
  newspaper: IconExNewspaper,
  paperclip: IconExPaperclip,
  products: IconExProducts,
  sport: IconExSport,
  student: IconExStudent,
  user: IconExUser,
  neptun: IconExNeptun,
  careeros: IconExCareerOS,
  moodle: IconExMoodle,
  edit: IconExEdit,
  programes: IconExProgrames,
  it: IconExIT,
  feedback: IconExFeedback,
  fresher: IconExFresher,
  schedule: IconExSchedule,
  mobilites: IconExMobilites,
  dormitory: IconExDormitory,
  competitions: IconExCompetitions,
  'student-associations': IconExStudentAssociations,
  colleges: IconExColleges,
  science: IconExScience,
  mentor: IconExMentor,
  'well-being': IconExWellBeing,
}
